import React from "react";
import ReactSelect from "react-select";

import { componentOverrides, styleOverrides } from "./config";

/**
 * @deprecated please use @streeteasy/design-system/form/SelectInput instead
 */
const Select = props => (
  <ReactSelect
    components={componentOverrides}
    styles={styleOverrides}
    {...props}
  />
);

Select.propTypes = { ...ReactSelect.propTypes };

export default Select;
